import { useViewport } from '@hooks/useViewport';
import { setSlideWidth } from '@actions/creators';
import { updateConnection } from '@services/sse';
import { updateCache } from '@services/redis-cache';
import { getBrowserStorageItem } from '@utils/browserStorage';
import { BROWSER_STORAGE_KEYS } from '@constants';
import { isValidNumber } from '@utils/validateInputs';
import useResizeObserver from '@react-hook/resize-observer';

function _validateDimension(dimension) {
    const isValidDimension = isValidNumber(dimension) && dimension !== 0;

    // Null is acceptable for PDF dimensions at the moment
    return isValidDimension || dimension === null;
}

export const sendDimensions = (dispatch, leadId) => async ({ width, height }) => {
    const heightIsValid = _validateDimension(height);
    const widthIsValid = _validateDimension(width);

    if (heightIsValid && widthIsValid) {
        if (width !== null) {
            useViewport(width, dispatch);
            dispatch(setSlideWidth(width));
        }

        const data = { 
            clientConnected: true, 
            dimensions: { 
                height: parseInt(height), 
                width: parseInt(width) 
            }
        };

        await updateConnection(leadId, data);
        await updateCache(leadId, data);
    }
};

export const useRefDimensions = (dispatch, targetRef, leadId) => {
    useResizeObserver(targetRef, async entry => {
        const { inlineSize: width, blockSize: height } = entry.borderBoxSize[0];

        await sendDimensions(dispatch, leadId)({ width, height });
    });
};

const { slideDimensionsKey } = BROWSER_STORAGE_KEYS;

export const loadDimensionsAndViewport = (dispatch, ref, key = slideDimensionsKey) => {
    const slideDimensions = getBrowserStorageItem(key);

    if (slideDimensions) {
        const { height, width } = slideDimensions;

        ref.current.style.height = `${height}px`;
        ref.current.style.width = `${width}px`;

        dispatch(setSlideWidth(width));

        const updatedViewport = useViewport(width, dispatch);

        return {
            viewport: updatedViewport,
            slideDimensions
        };
    } 

    return {
        viewport: null,
        slideDimensions: null
    };
};